import angular from "angular";

let mod = angular.module('RegisterRequests.registerRequest', [])
    .service('RegisterRequest', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/register-requests';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.reject = function (id, comment) {
            return $http.post(uri(id, 'reject'), {comment: comment});
        };

    }]);

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/register-requests-control/register-request.service.js